export default __webpack_public_path__ + "static/media/ecommerce-size-b.157e1b7c.png";